<template lang="pug">
v-container.pa-8
  .d-flex.pb-4
    v-menu(offset-y rounded="lg")
      template(v-slot:activator="{ on }")
        v-btn.px-0(text v-on="on") 
          .heading-5.text-none.mr-1 {{ selectedDuration.text }}
          v-icon $yzi-chevron-down
      v-list.py-0
        div(v-for="duration in durations")
          v-list-item(@click="selectDuration(duration)")
            v-list-item-title.text-sm.basic800--text.font-normal {{ duration.text }} {{ dateFromDuration(duration) }}
          v-divider.basic300
  v-divider.mb-6

  v-row.pb-2.pb-md-0(no-gutters)
    v-col(cols="12" md="6")
      v-tabs(v-model="appointmentTab" color="basic700" :height="44" :grow="isMobileScreen")
        v-tab.text-sm.font-semibold.text-capitalize.px-4 {{ $t('Subscribed') }}
        v-tab.text-sm.font-semibold.text-capitalize.px-4 {{ $t('Started') }}
        v-tab.text-sm.font-semibold.text-capitalize.px-4 {{ $t('Trained') }}
        v-tab.text-sm.font-semibold.text-capitalize.px-4 {{ $t('Deployed') }}
    v-col(cols="12" md="6" align="end")
      .d-flex.align-center
        v-spacer
        v-btn(@click="clickSearch" icon color="neutral500")
          v-icon(size="20") $yzi-search-sm
        v-text-field(v-if="showSearchField" v-model="searchText" @blur="blurSearch" @input="queryChanged" solo dense flat placeholder="Type to search..." hide-details clearable autofocus)
        v-btn.selected-button(v-if="filtersCount" @click="clickFilter" text small)
          v-icon(size="20") $yzi-filter-funnel-01
          .ml-1 {{ filtersCount }}
        v-btn(v-else @click="clickFilter" icon color="neutral500")
          v-icon(size="20") $yzi-filter-funnel-01
        .mr-2
          customize-column-menu(type="appointment" :showTooltip="false" iconSize="21")
        v-menu(offset-y left rounded="lg")
          template(#activator="{ on }")
            v-btn.button-sm(color="neutral700" outlined depressed v-on="on") {{ $t('action') }}
              v-icon(right) mdi-chevron-down
          v-list.py-0
            v-list-item(@click="editMessageTemplate")
              v-list-item-title.text-sm.basic800--text {{ $t('edit_message_template') }}
        v-btn.button-sm.ml-4(color="neutral700" dark depressed @click="addNewAppointment") {{ $t('new') }}
  v-divider

  .data-table
    v-data-table.mt-sm-4.pb-6(:headers="headers" :items="appointments" item-key="id" :items-per-page="pageSize" hide-default-footer :loading="isFetching" item-class="text-sm" :disable-sort="isMobileScreen" :header-props="{ sortIcon: '$yzi-triangle' }" @click:row="openAppointmentDetails" loader-height="2")
      template(v-slot:no-data)
        .mt-6
          v-img.mx-auto(src="@/assets/images/icon_empty.png" width=80)
          .mt-2.p2.basic600--text {{ $t('no_list_available') }}
      //- Name
      template(v-slot:item.lead="{ item, headers, index }")
        div.text-sm.font-semibold(v-if="item.lead && item.lead.name") {{ item.lead.name }}
      //- Date
      template(v-slot:item.date="{ item, headers, index }")
        div.text-sm(v-if="item.start") {{ item.start | humanizeDate }}
      //- Time
      template(v-slot:item.time="{ item, headers, index }")
        div.d-flex.align-center.font-semibold(v-if="item.start")
          div.text-xs {{ item.start | displayTime2 }}
          div.text-xs.ml-1(v-if="item.until") - {{ item.until | displayTime2 }}
        div.text-xs(v-if="item.services.length") {{ item.services.length > 1 ? `${item.services.length} services` : '1 service' }}
      //- Service
      template(v-slot:item.services="{ item, headers, index }")
        template(v-for="(service, index) in item.services")
          div.d-flex.align-center(v-if="index < 2" :key="`serv-${index}`")
            div.text-sm.table-word-break {{ service.name }}
            template(v-if="index === 1 && item.services.length > 2")
              v-spacer
              div.text-xs.font-medium +{{ item.services.length - 2 }} more
      //- Providers
      template(v-slot:item.provider="{ item, headers, index }")
        div(:id="`pv-${index}`" style="position: relative;")
        div.my-3(v-if="item.provider && Object.keys(item.provider).length")
          v-tooltip(top color="black" :attach="`#pv-${index}`" content-class="black tooltip-top-arrow")
            template(#activator="{ on, attrs }")
              div(v-bind="attrs" v-on="on")
                y-chip.cursor-help(v-bind="attrs" v-on="on" :label="getProviderName(item)" size="sm" chip-class="pa-1" outlined)
                  template(#prepend)
                    div.mr-1
                      template(v-if="item.type === 'combo'")
                        template(v-for="(set, idx) in item.combo_set")
                          v-avatar(size="20" color="neutral300" :class="idx > 0 ? 'stack-image' : ''" :key="set.provider.id")
                            template(v-if="set.provider.profile_image")
                              v-img(:src="`https://img.yezza.io/50x50/${set.provider.profile_image.path}`")
                            v-icon(v-else color="neutral500" size="15") $yzi-user-03
                      v-avatar(v-else size="20" color="neutral300")
                        template(v-if="item.provider.profile_image")
                          v-img(:src="`https://img.yezza.io/50x50/${item.provider.profile_image.path}`")
                        v-icon(v-else color="neutral500" size="15") $yzi-user-03
                      
            template(v-if="item.type === 'combo' && item.combo_set.length > 1")
              div(v-for="(set, idx) in item.combo_set" :key="`ttpv-${index}-${idx}`") {{ idx + 1 }}. {{ set.provider.name }}
            div(v-else) {{ item.provider.name }}
      //- Payment
      template(v-slot:item.paid="{ item, headers, index }")
        div.d-flex.align-center
          v-icon.mr-2(v-if="item.paid === false" :color="'danger500'" size="22") $yzi-alert-circle-solid
          v-icon.mr-2(v-else :color="'success500'" size="22") $yzi-check-circle-solid
          div.text-sm {{ item.paid === null ? 'N/A' : item.paid ? 'Paid' : 'Unpaid' }}
      //- Responses
      template(v-slot:item.responses="{ item, headers, index }")
        a
          div.text-sm.font-semibold.text-decoration-underline(@click="openAppointmentDetails(item)") View response
      //- Sent status
      template(v-slot:item.contacted="{ item, headers, index }")
        div.text-sm {{ item.lead.taggings.find(f => f.tagging === 'contacted') ? 'Sent' : 'Pending' }}
      //- Actions
      template(v-slot:item.actions="{ item, headers, index }")
        div.d-flex.align-center.justify-end.py-3(@click.stop)
          v-btn(icon small @click="clickWhatsapp(item)")
            v-icon mdi-whatsapp
          v-menu(offset-y left rounded="lg")
            template(#activator="{ on }")
              v-btn.ml-2(icon small v-on="on")
                v-icon mdi-dots-horizontal
            v-list.py-0
              template(v-for="(action, actidx) in actionList")
                template(v-if="action.id !== 'record' || (action.id === 'record' && item.paid === false)")
                  v-divider(v-if="actidx !== 0")
                  v-list-item(@click="action.action(item)" :key="'action-' + actidx")
                    v-list-item-title.text-sm.basic800--text {{ action.text }}
              template(v-if="item.lead && item.lead.taggings.find(f => f.tagging === 'contacted')")
                v-divider
                v-list-item(@click="openMarkSentPending(item)")
                  v-list-item-title.text-sm.basic800--text {{ $t('mark_sent_pending') }}
    
    div.d-flex.align-center(v-if="totalCount > pageSize")
      v-spacer
      div
        yc-pagination-custom(v-model="currentPage" :parentPageSize.sync="pageSize" :count="totalCount" text="Show appointments" @input="pageChanged")

  filter-appointment-drawer(:open.sync="showFilterDrawer" @done="doneFilter")
  .modals
    add-appointment(v-if="openNewAppointmentDialog" :open.sync="openNewAppointmentDialog" @closed="closed" @reset="reset")
    view-appointment-details(v-if="openAppointmentDetailsDialog" :open.sync="openAppointmentDetailsDialog" :selectedAppointment="selectedAppointment" :tabIndex="appointmentTab" @closed="closed" @reset="reset")
    mark-as-arrived(v-if="openMarkAsArrivedDialog" :open.sync="openMarkAsArrivedDialog" :selectedAppointment="selectedAppointment" @closed="closed" @reset="reset")
    reschedule-date(v-if="openRescheduleDateDialog" :open.sync="openRescheduleDateDialog" :selectedAppointment="selectedAppointment" @closed="closed" @reset="reset")
    cancel-appointment(v-if="openCancelAppointmentDialog" :open.sync="openCancelAppointmentDialog" :selectedAppointment="selectedAppointment" @closed="closed" @reset="reset")
    follow-up-appointment(v-if="openFollowUpDialog" :open.sync="openFollowUpDialog" :selectedAppointment="selectedAppointment" @closed="closed" @reset="reset")
    record-payment(v-if="openRecordPaymentDialog" :open.sync="openRecordPaymentDialog" :selectedAppointment="selectedAppointment" @closed="closed" @reset="reset")
    mark-sent-pending(v-if="openMarkSentPendingDialog" :open.sync="openMarkSentPendingDialog" :selectedAppointment="selectedAppointment" @closed="closed" @reset="reset")

</template>

<script>
import { debounce } from '@/utils'
import { mapGetters, mapActions } from 'vuex'
import { DateTime } from 'luxon'
import AddAppointment from '@/components/clinic/dialogs/AddAppointment.vue'
import ViewAppointmentDetails from '@/components/clinic/dialogs/ViewAppointmentDetails.vue'
import MarkAsArrived from '@/components/clinic/dialogs/MarkAsArrived.vue'
import RescheduleDate from '@/components/clinic/dialogs/RescheduleDate.vue'
import CancelAppointment from '@/components/clinic/dialogs/CancelAppointment.vue'
import FollowUpAppointment from '@/components/clinic/dialogs/FollowUpAppointment.vue'
import RecordPayment from '@/components/clinic/dialogs/RecordPayment.vue'
import MarkSentPending from '@/components/clinic/dialogs/MarkSentPending.vue'
import FilterAppointmentDrawer from '@/components/clinic/appointment/filter/FilterAppointmentDrawer.vue'
import CustomizeColumnMenu from '../../../components/connect/CustomizeColumnMenu.vue'

export default {
  name: 'Appointment',
  components: { AddAppointment, ViewAppointmentDetails, MarkAsArrived, RescheduleDate, CancelAppointment, FollowUpAppointment, RecordPayment, MarkSentPending, FilterAppointmentDrawer, CustomizeColumnMenu },
  props: {
    isSelectionMode: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      isFetching: false,
      openNewAppointmentDialog: false,
      openAppointmentDetailsDialog: false,
      openMarkAsArrivedDialog: false,
      openRescheduleDateDialog: false,
      openCancelAppointmentDialog: false,
      openFollowUpDialog: false,
      openRecordPaymentDialog: false,
      openMarkSentPendingDialog: false,
      selectedAppointment: null,
      appointmentTab: 0,
      searchText: '',
      pageSize: 20,
      totalCount: 0,
      currentPage: 1,
      appointments: [],
      selectedAppointments: [],
      showFilterDrawer: false,
      isDeleting: false,
      statuses: [
        { status: 'new,processed', id: 0 },
        { status: 'received', id: 1 },
        { status: 'absent', id: 2 },
        { status: 'cancelled', id: 3 },
      ],
      actions: [
        { id: 'mark', text: this.$t('mark_as_arrived'), action: (item) => (this.openMarkAsArrived(item)) },
        { id: 'reschedule', text: this.$t('reschedule_new_date'), action: (item) => (this.openRescheduleDate(item)) },
        { id: 'cancel', text: this.$t('cancel_this_appointment'), action: (item) => (this.openCancelAppointment(item)) },
        { id: 'followup', text: this.$t('create_followup_appointment'), action: (item) => (this.openFollowUpAppointment(item)) },
        { id: 'record', text: this.$t('record_payment'), action: (item) => (this.openRecordPayment(item)) },
      ],
      analytics: null,
      selectedDuration: { id: 'month', text: 'This month' },
      showSearchField: false,
      filters: null,
      durations: [
        { id: 'day', text: 'Today' },
        { id: 'week', text: 'This week' },
        { id: 'month', text: 'This month' },
        { id: 'year', text: 'This year' },
        { id: 'all', text: 'All time' }
      ]
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      clinic: 'clinic/getClinic',
      appointmentFields: 'clinic/getAppointmentFields'
    }),
    actionList () {
      const upcoming = ['mark', 'reschedule', 'cancel', 'followup', 'record']
      const completed = ['followup', 'record']
      const absent = ['mark', 'reschedule', 'cancel', 'followup', 'record']
      const cancelled = ['reschedule', 'followup', 'record']
      if (this.appointmentTab === 0) { return upcoming.map(m => { return { ...this.actions.find(f => f.id === m) } }) }
      if (this.appointmentTab === 1) { return completed.map(m => { return { ...this.actions.find(f => f.id === m) } }) }
      if (this.appointmentTab === 2) { return absent.map(m => { return { ...this.actions.find(f => f.id === m) } }) }
      if (this.appointmentTab === 3) { return cancelled.map(m => { return { ...this.actions.find(f => f.id === m) } }) }
      return this.actions
    },
    headers () {
      const name = {
        text: 'Name',
        value: 'lead',
        enable: true,
        class: 'text-xs font-bold neutral500--text text-uppercase'
      }
      const fields = this.appointmentFields.filter(item => item.enable)
      fields.map(item => {
        item.text = item.field_name
        item.value = item.id
        item['class'] = 'text-xs font-bold neutral500--text text-uppercase'
      })
      const actions = {
        text: 'Actions',
        value: 'actions',
        enable: true,
        class: 'text-xs font-bold text-end neutral500--text text-uppercase',
        sortable: false
      }
      return [name, ...fields, actions]
    },
    isMobileScreen () {
      return this.$vuetify.breakpoint.xs
    },
    filtersCount () {
      if (this.filters) {
        let count = this.filters.length
        this.filters.forEach(item => {
          const betweenKeys = ["date__lte", "time__lte"]
          if (betweenKeys.includes(item.key)) {
            count--
          }
        })
        return count
      }
      return 0
    }
  },
  watch: {
    appointmentTab () {
      this.searchText = null
      this.fetchAppointments(1)
    },
    pageSize () {
      this.fetchAppointments(1)
    }
  },
  mounted () {
    this.fetchAppointments(1)
    this.fetchAnalytics()
    if (!this.clinic) {
      this.fetchClinic()
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchClinic () {
      this.$axios.get(`/clinics/${this.company.slug}?expand=form,company`)
        .then(resp => {
          this.$store.commit('clinic/setClinic', resp.data)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    fetchAnalytics () {
      this.analytics = null
      const params = this.selectedDuration.id !== 'all' ? { span: this.selectedDuration.id } : null
      this.$axios.get(`/clinics/${this.company.slug}/appointments/analytics`, { params })
        .then(resp => {
          this.analytics = resp.data
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    fetchAppointments (page) {
      this.isFetching = true
      const params = {
        page_size: this.pageSize,
        page,
        search: this.searchText || '',
        statuses: this.statuses.find(f => f.id === this.appointmentTab).status || '',
        ordering: 'start'
      }
      if ((params.statuses.includes('new') || params.statuses.includes('processed')) && this.selectedDuration.id !== 'all') {
        params['span'] = this.selectedDuration.id
      }
      if (this.filters && this.filters.length) {
        this.filters.forEach(filter => {
          params[filter.key] = filter.value
        })
        delete params.span
      }
      this.$axios.get(`/clinics/${this.company.slug}/appointments`, { params })
        .then(resp => {
          if (resp?.data.results) {
            this.appointments = resp.data.results
            this.appointments.map(m => m.checked = false)
          }
          this.totalCount = resp.data.count
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    pageChanged (num) {
      this.fetchAppointments(num)
    },
    queryChanged: debounce(function () {
      this.fetchAppointments(1)
    }, 750),
    successDeleteAppointment () {
      this.reset()
    },
    clickItem (item) {
      this.$router.push(`/admin/donation/appointment/${item.slug}`)
    },
    closed () {
      this.selectedAppointments = []
      this.selectedAppointment = null
    },
    reset () {
      this.selectedAppointments = []
      this.selectedAppointment = null
      this.fetchAppointments(1)
    },
    emitselectedAppointments () {
      this.$emit('onselectedAppointments', this.selectedAppointments)
    },
    addNewAppointment () {
      this.openNewAppointmentDialog = true
    },
    openAppointmentDetails (item) {
      this.selectedAppointment = item
      this.openAppointmentDetailsDialog = true
    },
    openMarkAsArrived (item) {
      this.selectedAppointment = item
      this.openMarkAsArrivedDialog = true
    },
    openRescheduleDate (item) {
      this.selectedAppointment = item
      this.openRescheduleDateDialog = true
    },
    openCancelAppointment (item) {
      this.selectedAppointment = item
      this.openCancelAppointmentDialog = true
    },
    openFollowUpAppointment (item) {
      this.selectedAppointment = item
      this.openFollowUpDialog = true
    },
    openRecordPayment (item) {
      this.selectedAppointment = item
      this.openRecordPaymentDialog = true
    },
    openMarkSentPending (item) {
      this.selectedAppointment = item
      this.openMarkSentPendingDialog = true
    },
    editMessageTemplate () {
      this.$router.push('/admin/clinic/message-template')
    },
    clickWhatsapp (item) {
      console.log({item});
      const endpoint = `/leads/${item.lead.pid}/taggings/contacted`
      this.$axios.patch(endpoint)
        .then(resp => {
          this.updateActivityLog(endpoint, resp, item.lead.pid)
          const taggings = [resp.data]
          this.$set(item.lead, 'taggings', taggings)
        })
        .catch(() => {})

      let storeUrl = `https://${this.company.slug}.yezza.co/appointment`

      let message = `Hi ${item.lead.name}!%0d%0a%0d%0aWe see that you missed your appointment at ${this.$options.filters.displayTime2(item.time)}.%0d%0a%0d%0aWould you like to book another appointment? You can do so here:%0d%0a%0d%0a${storeUrl}`
      message = this.$options.filters.encodeSymbols(message)
      if (this.getMessageTemplate()) {
        message = this.getMessageTemplate()
        message = message.split('{{name}}').join(item.lead.name ? encodeURIComponent(item.lead.name) : '')
        message = message.split('{{doctor}}').join(item.provider.name ? encodeURIComponent(item.provider.name) : '')
        // message = message.split('{{doctor}}').join(item.providers.length && item.providers.map(m => m.name).join() ? encodeURIComponent(item.providers.map(m => m.name).join(', ')) : '')
        message = message.split('{{service}}').join(item.services.length && item.services.map(m => m.name).join() ? encodeURIComponent(item.services.map(m => m.name).join(', ')) : '')
        message = message.split('{{date}}').join(item.start ? encodeURIComponent(this.$options.filters.humanizeDate(item.start)) : '')
        message = message.split('{{time}}').join(item.start ? encodeURIComponent(this.$options.filters.displayTime2(item.start)) : '')
        message = message.split('{{appointment_link}}').join(storeUrl || '')
        let preAppts = item.services.filter(f => f.instructions.pre_appointment && f.instructions.pre_appointment.label)
        let postAppts = item.services.filter(f => f.instructions.post_appointment && f.instructions.post_appointment.label)
        message = message.split('{{pre_appt_instruction}}').join(encodeURIComponent(preAppts.length ? preAppts.map(m => { return m.instructions.pre_appointment.label + '\n\n' + m.instructions.pre_appointment.instructions }).join('\n\n') : ''))
        message = message.split('{{post_appt_instruction}}').join(encodeURIComponent(postAppts.length ? postAppts.map(m => { return m.instructions.post_appointment.label + '\n\n' + m.instructions.post_appointment.instructions }).join('\n\n') : ''))
        message = message.split(/\n/g).join('%0d%0a')
        message = this.$options.filters.encodeSymbols(message)
      }
      // const platform = navigator.platform || ''
      // console.log(platform)
      let prefix = 'api'
      // if (platform.toLowerCase().includes('win')) {
      //   prefix = 'web'
      // }
      window.open(`https://${prefix}.whatsapp.com/send?phone=${item.lead.phone}&text=${message}&app_absent=1`)
    },
    getMessageTemplate () {
      if (!this.clinic) {
        return null
      }
      if (this.appointmentTab === 0) {
        return this.clinic.upcoming_reminder
      } else if (this.appointmentTab === 2) {
        return this.clinic.absent_reminder
      } else {
        return this.clinic.review_reminder
      }
    },
    getPotentialSales () {
      if (this.analytics) {
        const { upcoming, completed, cancelled, absent } = this.analytics
        const sales = (upcoming + completed + cancelled + absent) * 100
        return this.$options.filters.displayPriceNoCent(sales * this.$currency.multiplier, this.$currency)
      }
      return `${this.$currency.symbol} 0`
    },
    getProviderName (item) {
      let str = ''
      if (item.type === 'combo' && item.combo_set.length > 1) {
        str = item.combo_set.length + ' providers'
      } else {
        str = item.provider.name
        if (str.length > 15) {
          str = str.substring(0, 15 - 3) + '...';
        }
      }
      return str
    },
    selectDuration (duration) {
      this.selectedDuration = duration
      this.filters = []
      this.fetchAnalytics()
      this.fetchAppointments(1)
    },
    clickSearch () {
      if (this.showSearchField) {
        if (!this.searchText || this.searchText.length === 0) {
          this.showSearchField = false
        }
      } else {
        this.showSearchField = true 
      }
    },
    blurSearch () {
      if (!this.searchText || this.searchText.length === 0) {
        this.showSearchField = false
      }
    },
    clickFilter () {
      this.showFilterDrawer = true
    },
    doneFilter (filters) {
      this.filters = filters
      this.fetchAppointments(1)
    },
    dateFromDuration ({ id }) {
      const now = DateTime.local()
      switch (id) {
        case 'day':
          return `(${now.toFormat('dd MMMM yyyy')})`
        case 'week': {
          const start = DateTime.local().startOf('week')
          const startDay = start.toFormat('dd')
          const endDay = start.plus({days: 6}).toFormat('dd MMMM yyyy')
          return `(${startDay} - ${endDay})`
        }
        case 'month':
          return `(${now.toFormat('MMMM yyyy')})`
        case 'year':
          return `(${now.toFormat('yyyy')})`
        case 'all':
          return ''
      }
    },
    updateActivityLog (endpoint, response, id) {
      let data = {
        company: this.company.id,
        object_id: id || null,
        object_ref: 'appointment',
        activity: this.appointmentTab === 0 ? 'Send reminder to upcoming appointment' : this.appointmentTab === 2 ? 'Send reminder to no show appointment' : 'Send reminder to review appointment' ,
        raw_data: { endpoint, response: response.data }
      }
      this.$axios.post('/users/logs', data)
        .catch(() => {})
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.selected-button {
  background: #EEEEEE !important;
  border-radius: 16px;
}
.table-word-break {
  word-break: break-word;
}
::v-deep svg.v-icon.notranslate.v-data-table-header__icon {
  height: 8px !important;
  width: 8px !important;
  margin-left: 8px;
}
::v-deep .v-data-table__wrapper table tbody tr:hover{
  cursor: pointer;
  background: var(--v-neutral200) !important; 
}
.stack-image {
  margin-left: -13px;
}
</style>